import { AppEnvironment } from './environment.model';
import { environmentBase } from './environment.erikorgu';

export const environment: AppEnvironment = {
  ...environmentBase,
  INTERCOM_APP_ID: 'v1jv4f5y',
  INTERCOM_APP_ID_IOS: 'ios_sdk-b10f5e00257e20e05a2f1422bd5809ef3ceb9e12',
  INTERCOM_APP_ID_ANDROID: 'android_sdk-710fccb22ed7b2db68fb5cd68e198fb53723048e',
  BANKLINK_PUBLIC_KEY: '33FsXjKtxxkCeYQcRcPccOHullNLWxvh',
};
